import styled from 'styled-components';

export default styled.div`
    flex: 1;
    width: 0;
    flex-grow: ${({ flexGrow }) => flexGrow};
`;
